export default "__VITE_PUBLIC_ASSET__99ed6e3f__"